export default (value, installments) => String(parseFloat(value / installments).toFixed(2)).replace('.', ',');
